import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
// import CardContent from '@material-ui/core/CardContent';
// import IconButton from '@material-ui/core/IconButton';
import red from '@material-ui/core/colors/red';
import Avatar from '@material-ui/core/Avatar';
// import GridList from '@material-ui/core/GridList';
// import GridListTile from '@material-ui/core/GridListTile';
// import GridListTileBar from '@material-ui/core/GridListTileBar';
// import InfoIcon from '@material-ui/icons/Info';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { connect } from "react-redux";
import { compose } from "redux";
import { fetchPublicTeams } from "../actions/TeamAction";
import { ATTACHMENT_END_POINT } from "../helpers/constants";
import notfound from '../assets/notfound.png';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
// import CardActions from '@material-ui/core/CardActions';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from '@material-ui/core/Link';

// import Button from '@material-ui/core/Button';

// import Button from '@material-ui/core/Button';
// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import Fab from "@material-ui/core/Fab";
// import ClearIcon from "@material-ui/icons/Clear";
// import { Link } from "react-router-dom";

const { innerWidth } = window;

const styles = theme => ({
    image: {
        top: "79%",
        width: "100%",
        position: 'relative',
        transform: 'translateY(-50%)'
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
        // height: 250,
        // width: '100%'
    },
    actions: {
        display: 'flex',
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    root: {
        flexGrow: 1,
        padding: 20
    },
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
    closeButtonRoleFab: {
        float: 'right',
        marginRight: '-44px',
        // marginTop: '-44px'
        marginTop: '-84px'
    },
    title: {
        color: '#000000',
        fontSize: 13,
        fontWeight: "Bold"
    },
    headerTextColor: {
        color: '#1E1759',
        fontWeight: 'bold',
        lineHeight: 1.8,
    },
    centerText: {
        textAlign: 'center'
    },
    gradientButton: {
        // background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)'
        // background: '#6128be'
        // background: '#86C42B'
        background: '#2cc676',
        '&:focus': {
            background: '#27ad67'
        },
        '&:hover': {
            background: '#27ad67'
        },
        '&:active': {
            background: '#27ad67'
        }
    }
});

class FLLTeam extends Component {
    state = {
        open: false,
        selectedPlayer: null        
    }

    componentDidMount() {
        this.props.dispatch(fetchPublicTeams())
    }

    handleClick = () => {
        this.setState({ open: !this.state.open });
    };

    handleChange = (player) => {
        this.setState({ selectedPlayer: player, open: !this.state.open });
    };

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <Grid container spacing={16}>
                    <Grid item xs={12} className={classes.centerText} key={0}>
                        <Typography variant="h4" className={`${classes.grow} ${classes.headerTextColor}`}>
                            Teams
                        </Typography>
                    </Grid>

                    {this.props.publicTeams.map(row => (
                        <Grid item xs={innerWidth > 480 ? 6 : 12 } key={row.id}>
                            <Card className={classes.card}>
                                <CardHeader
                                    classes={{
                                        title: classes.title,
                                    }}
                                    avatar={
                                        <Avatar aria-label="Recipe" src={require('../assets/team.png')} className={classes.avatar}></Avatar>
                                    }
                                    title={row.team_name}
                                />
                                <CardMedia
                                    className={classes.media}
                                    image={row.attachments.length > 0 ? `${ATTACHMENT_END_POINT}${row.attachments[0].file_name}` : notfound}
                                />
                                <CardContent>
                                    <Typography component="p" gutterBottom style={{ marginBottom: 15 }}>
                                        <FontAwesomeIcon icon="address-book" style={{ fontSize: 12, marginRight: 5 }} />
                                        {row.city}
                                    </Typography>
                                    <Typography component="p" gutterBottom style={{ marginBottom: 15 }}>
                                        <FontAwesomeIcon icon="link" style={{ fontSize: 12, marginRight: 5 }} />
                                        <Link href={row.website_url} className={classes.link}> {row.website_url !== "undefined" ? row.website_url : null}</Link>
                                    </Typography>
                                    <Typography component="p" gutterBottom style={{ textAlign: "justify" }}>
                                        {row.description}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        publicTeams: state.TeamReducer.publicTeams
    }
}

FLLTeam.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(withStyles(styles), connect(mapStateToProps))(FLLTeam);



